import MobileView from './MobileView';

export default MobileView;
